module.exports = __webpack_public_path__ + "static/media/bass-cello.33bf86db.mp3";